const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://icztl26hbbegvilgvpoh2ifo7y.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-fd5jxf4fi5e57l73o7yr2bj4ki"
};

export default awsmobile;
